module.exports = __webpack_public_path__ + "media/images/writer/story_achievement_mailer/ogp_image_rank_no3-2f60ceacfeee2776e6c3c8a626a018e2.png";